export default __webpack_public_path__ + "static/media/Frame 15.168313ec.svg";